module.exports = __webpack_public_path__ + "img/code.920cc63a.png";